import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { cn } from '../lib/format';
import MusicDisc from './MusicDisc';
import SearchBox from './SearchBox';

const NAV_ITEMS = [
  { to: '/', label: '首页', end: true },
  { to: '/about', label: '关于' },
  { to: '/projects', label: '项目' },
  { to: '/blog', label: '博客' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={cn('site-header', scrolled && 'site-header-scrolled')}>
      <div className="container header-inner">
        <Link to="/" className="brand" aria-label="铁头功的博客首页">
          <img className="brand-logo" src="/favicon.png" alt="" aria-hidden="true" />
          <span className="brand-name">铁头功的博客</span>
        </Link>

        <SearchBox className="header-search-desktop" />

        <div className="header-right">
          <nav className="main-nav" aria-label="主导航">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => cn('nav-link', isActive && 'nav-link-active')}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <MusicDisc />

          <button
            type="button"
            className="nav-toggle"
            aria-label={menuOpen ? '关闭菜单' : '展开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="mobile-nav">
          <SearchBox className="header-search-mobile" onSubmitted={() => setMenuOpen(false)} />
          <nav aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => cn('mobile-nav-link', isActive && 'nav-link-active')}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
